// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportQuarantineDataResponseContent
 */
export interface ExportQuarantineDataResponseContent {
    /**
     * 
     * @type {string}
     * @memberof ExportQuarantineDataResponseContent
     */
    downloadUrl: string;
    /**
     * 
     * @type {number}
     * @memberof ExportQuarantineDataResponseContent
     */
    expiresIn: number;
}

/**
 * Check if a given object implements the ExportQuarantineDataResponseContent interface.
 */
export function instanceOfExportQuarantineDataResponseContent(value: object): value is ExportQuarantineDataResponseContent {
    if (!('downloadUrl' in value) || value['downloadUrl'] === undefined) return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false;
    return true;
}

export function ExportQuarantineDataResponseContentFromJSON(json: any): ExportQuarantineDataResponseContent {
    return ExportQuarantineDataResponseContentFromJSONTyped(json, false);
}

export function ExportQuarantineDataResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportQuarantineDataResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'downloadUrl': json['downloadUrl'],
        'expiresIn': json['expiresIn'],
    };
}

export function ExportQuarantineDataResponseContentToJSON(json: any): ExportQuarantineDataResponseContent {
    return ExportQuarantineDataResponseContentToJSONTyped(json, false);
}

export function ExportQuarantineDataResponseContentToJSONTyped(value?: ExportQuarantineDataResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'downloadUrl': value['downloadUrl'],
        'expiresIn': value['expiresIn'],
    };
}
